module.exports = __WEBPACK_EXTERNAL_MODULE_gui_editor_guiEditor__;